/* eslint-disable @typescript-eslint/naming-convention */
import { MotorLossMapID } from 'src/api';

export const motorLossMap: MotorLossMapID = {
  data_id: '',
  component_type: 'MotorLossMapID',
};
